import DrawerButton from "components/form/Franchise-vendor-vehicleallot-drawerbtn";
import Error from "components/form/Error";
import InputArea from "components/form/InputArea";
import LabelArea from "components/form/LabelArea";
import Title from "components/form/Title";
import useVehicleAllotSubmit from "hooks/useVehicleAllotSubmit";
import ActiveButton from "components/form/ActiveButton";
import DrawerCancelNext from "components/form/DrawerCancelNext";
import DrawerPreviousSubmit from "components/form/DrawerPreviousSubmit";
import React, { useState, useEffect } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import Select from "react-select";
import InputAreaDate from "components/form/InputAreaDate";
import { notifyError } from "utils/toast";

const IndicatorSeparator = () => null;

const VehicleAllotDrawer = ({
  id,
  vehicles,
  drivers,
  data,
  tab,
  action,
  assigned_vehicle,
  assigned_driver,
  isOpen,
  clientArrived,
  package_type,
  days,
}) => {
  const [choice, setChoice] = useState("");
  const {
    register,
    trigger,
    handleSubmit,
    onSubmit,
    errors,
    selectedVehicle,
    setSelectedVehicle,
    setvehicleName,
    selectedDriver,
    setSelectedDriver,
    setdriverName,
    startDate,
    goToStep,
    step,
    handleNextStep,
    handlePreviousStep,
    setEndDate,
    setStartDate,
    allotvehicle,
    handleSubmitStep,
    allotdriver,
    alreadyAssignedVehicle,
    alreadyAssignedDriver,
    loading,
    endDate,
    changeReason,

    setChangeReason,
    setTrip,
    tripwent,
    tripStartDate,
    setTripStartDate,
  } = useVehicleAllotSubmit(data, tab, choice, action);

  // const showTripWent =
  //   action === "modify" &&
  //   !["Airport Pickup", "Airport Drop", "Hour Rental"].includes(package_type) &&
  //   (package_type !== "Outstation" || Number(days) > 1);

  const showTripWent =
    action === "modify" &&
    !["Airport Pickup", "Airport Drop", "Hour Rental"].includes(package_type) &&
    ((package_type !== "Outstation" &&
      package_type !== "Holiday Package" &&
      package_type !== "Oneway") ||
      Number(days) > 1);

  useEffect(() => {
    if (!isOpen || action !== "modify") return;

    // Trip Went is NOT applicable
    if (
      ["Airport Pickup", "Airport Drop", "Hour Rental"].includes(package_type)
    ) {
      setTrip(false);
      return;
    }

    // Outstation, Holiday Package and Oneway
    // are applicable only when more than 1 day
    if (
      ["Outstation", "Holiday Package", "Oneway"].includes(package_type) &&
      Number(days) <= 1
    ) {
      setTrip(false);
      return;
    }

    // Client hasn't arrived
    if (!clientArrived) {
      setTrip(false);
      return;
    }

    // Eligible package + client arrived
    setTrip(true);
  }, [isOpen, action, package_type, days, clientArrived]);

  let vehicleOptions = [];
  let driverOptions = [];
  const presentAllotment = data?.allotment_history?.find(
    (item) => item.status === "Present",
  );

  const parseDDMMYYYY = (dateString) => {
    if (!dateString) return null;

    const [day, month, year] = dateString.split("-");
    return new Date(year, month - 1, day);
  };

  const minimumStartDate = parseDDMMYYYY(presentAllotment?.va_start_date);
  const minimumEndDate = parseDDMMYYYY(presentAllotment?.va_end_date);
  const handleChange = (selectedOption) => {
    setSelectedVehicle(selectedOption?.value);
    setvehicleName(selectedOption?.label);
  };

  const handleDriverChange = (selectedOption) => {
    setSelectedDriver(selectedOption?.value);
    setdriverName(selectedOption?.label);
  };

  const validateForm = () => {
    if (action !== "allot" && tab !== 0) {
      if (
        !startDate ||
        !endDate ||
        (!choice && tab !== 0 && action === "allot") ||
        (!changeReason && tab !== 0 && action === "allot")
      ) {
        notifyError("All fields are mandatory. Please fill all fields.");
        return false;
      } else if (
        choice === "vehicle" &&
        tab !== 0 &&
        (action === "allot" || action === "modify") &&
        (!selectedVehicle ||
          !vehicleOptions?.some((option) => option.value === selectedVehicle))
      ) {
        notifyError("Please select a vehicle.");
        return false;
      } else if (
        choice === "driver" &&
        tab !== 0 &&
        (action === "allot" || action === "modify") &&
        (!selectedDriver ||
          !driverOptions?.some((option) => option.value === selectedDriver))
      ) {
        notifyError("Please select a driver.");
        return false;
      } else if (
        choice === "both" &&
        tab !== 0 &&
        (action === "allot" || action === "modify") &&
        (!selectedVehicle ||
          !selectedDriver ||
          !vehicleOptions?.some((option) => option.value === selectedVehicle) ||
          !driverOptions?.some((option) => option.value === selectedDriver))
      ) {
        notifyError("Please select both vehicle and driver.");
        return false;
      }
    } else {
      if (!selectedVehicle || !selectedDriver) {
        notifyError("Please select both vehicle and driver.");
        return false;
      }
    }
    return true;
  };

  const handleFinalSubmit = (event) => {
    event.preventDefault();
    if (validateForm()) {
      handleSubmit(onSubmit)();
    }
  };

  // Utility to merge, flatten, and deduplicate assigned IDs
  const extractAssignedIds = (sources, key) => {
    return [
      ...new Set(
        sources
          .filter(Boolean)
          .flat(Infinity)
          .map((item) => item?.[key]?.toString())
          .filter(Boolean),
      ),
    ];
  };

  // Combine all possible assigned vehicle data
  const assignedVehicleIds = extractAssignedIds(
    [alreadyAssignedVehicle, assigned_vehicle],
    "va_vehicle_id",
  );

  // Combine all possible assigned driver data
  const assignedDriverIds = extractAssignedIds(
    [alreadyAssignedDriver, assigned_driver],
    "va_driver_id",
  );

  // console.log('assignedVehicleIds:', assignedVehicleIds);
  // console.log('assignedDriverIds:', assignedDriverIds);

  // Map vehicle options with conditional disabling
  vehicleOptions = [...(allotvehicle || []), ...(vehicles || [])].map(
    (vehicle) => {
      const vehicleId = vehicle.vehicle_id?.toString();
      const isDisabled =
        assignedVehicleIds.includes(vehicleId) && selectedVehicle !== vehicleId;

      return {
        value: vehicleId,
        label: `${vehicle.vehicle_type} (${vehicle.vehicle_reg_no}) ${isDisabled ? "(On Duty)" : ""}`,
        disabled: isDisabled,
      };
    },
  );

  // Map driver options with conditional disabling
  driverOptions = [...(allotdriver || []), ...(drivers || [])].map((driver) => {
    const driverId = driver.driver_id?.toString();
    const isDisabled =
      assignedDriverIds.includes(driverId) && selectedDriver !== driverId;

    return {
      value: driverId,
      label: `${driver.driver_name} (${driver.driver_contact_no}) ${isDisabled ? "(On Duty)" : ""}`,
      disabled: isDisabled,
    };
  });

  const selectOption = ["Driver", "Vehicle", "Both"];
  useEffect(() => {
    if (!isOpen) {
      setChoice("");
      setSelectedVehicle(null);
      setvehicleName("");
      setSelectedDriver(null);
      setdriverName("");
      setChangeReason("");
      // setStartDate("");
      // setEndDate("");
    }
  }, [isOpen]);
  useEffect(() => {}, [isOpen]);
  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {action === "allot" ? (
          <Title title={"Allot Vehicle"} description={""} />
        ) : (
          <Title title={"Modify Vehicle"} description={""} />
        )}
      </div>

      <div className="text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-400">
        <ul className="flex flex-wrap -mb-px">
          {[
            ...(action === "allot"
              ? []
              : [
                  { tabValue: 1, labelName: "Modify Vehicle or Driver" },
                  { tabValue: 2, labelName: "Modify New Vehicle or Driver" },
                ]),
          ].map(({ tabValue, labelName }) => (
            <li className="mr-2" key={tabValue}>
              <ActiveButton
                tabValue={tabValue}
                labelName={labelName}
                goToStep={goToStep}
                step={step}
              />
            </li>
          ))}
        </ul>
      </div>

      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <form onSubmit={handleFinalSubmit}>
          <div className="px-5 pt-5 flex-grow scrollbar-hide w-full max-h-full pb-20">
            {step === 1 && action === "modify" && (
              <>
                <div className="grid grid-cols-12 gap-5 mb-6 items-center">
                  <div className="col-span-12">
                    <LabelArea label="Select Option:" required />
                    <div className="flex gap-5">
                      {selectOption.map((option) => (
                        <label
                          key={option}
                          className="flex items-center space-x-1"
                        >
                          <input
                            type="radio"
                            name="choice"
                            checked={choice === option.toLowerCase()}
                            value={option.toLowerCase()}
                            // checked={choice === option.toLowerCase()}
                            // onChange={(e) => setChoice(e.target.value)}
                            onChange={(e) => {
                              setChoice(e.target.value);
                              setSelectedDriver(null);
                              setdriverName("");
                              setSelectedVehicle(null);
                              setvehicleName("");
                            }}
                            className="form-radio"
                          />
                          <span>{option}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                  {/* Trip Went - only for allowed package types */}
                  {showTripWent && (
                    <div className="col-span-12 sm:col-span-12">
                      {!clientArrived && (
                        <p className="text-sm text-red-600 mb-2">
                          Client has not arrived yet. Trip Went option will be
                          available once the client arrives.
                        </p>
                      )}

                      <LabelArea label="Trip Went:" />

                      <div className="flex items-center space-x-4">
                        {/* NO */}
                        <label className="flex items-center cursor-pointer">
                          <input
                            type="radio"
                            name="tripwent"
                            checked={tripwent === false}
                            onChange={() => {
                              if (!clientArrived) return;
                              setTrip(false);
                            }}
                            className="mr-2 accent-blue-600"
                          />
                          No
                        </label>

                        {/* YES */}
                        <label className="flex items-center cursor-pointer">
                          <input
                            type="radio"
                            name="tripwent"
                            checked={tripwent === true}
                            onChange={() => {
                              if (!clientArrived) return;
                              setTrip(true);
                            }}
                            className="mr-2 accent-blue-600"
                          />
                          Yes
                        </label>
                      </div>

                      {tripwent && (
                        <p className="mt-4 mb-0 text-sm">
                          New vehicle and driver start date
                        </p>
                      )}
                    </div>
                  )}

                  {/* Dates */}
                  {showTripWent && tripwent && (
                    <>
                      <div className="col-span-6">
                        <LabelArea label="Start Date" required />

                        <InputAreaDate
                          trigger={trigger}
                          register={register}
                          label="Start Date"
                          name="start_date"
                          type="date"
                          value={tripStartDate}
                          onChange={(date) => {
                            setTripStartDate(date || null);
                          }}
                          min={minimumStartDate}
                          max={new Date(endDate)}
                        />

                        <Error errorName={errors.start_date} />
                      </div>

                      <div className="col-span-6">
                        <LabelArea label="End Date" required />

                        <InputAreaDate
                          trigger={trigger}
                          register={register}
                          label="End Date"
                          name="end_date"
                          type="date"
                          value={new Date(endDate)}
                          onChange={(date) => {
                            setEndDate(date);
                          }}
                          max={minimumEndDate}
                          readOnly={true}
                          min={new Date(startDate)}
                        />

                        <Error errorName={errors.end_date} />
                      </div>
                    </>
                  )}
                </div>

                <DrawerCancelNext handleNextStep={handleNextStep} />
              </>
            )}

            {step === 2 && action === "modify" && (
              <div className="grid grid-cols-12 gap-5 mb-6 items-center">
                {(choice === "vehicle" || choice === "both") && (
                  <div className="col-span-6">
                    <LabelArea label={"Select Vehicle"} required />
                    <Select
                      id="vehicle-select"
                      options={vehicleOptions}
                      value={vehicleOptions?.find(
                        (option) => option.value === selectedVehicle,
                      )}
                      onChange={handleChange}
                      placeholder="Select Vehicle"
                      name="vehicle"
                      isOptionDisabled={(option) => option.disabled}
                      components={{ IndicatorSeparator }}
                      noOptionsMessage={() => "No vehicles found"}
                    />
                    <Error errorName={errors.vehicle} />
                  </div>
                )}

                {(choice === "driver" || choice === "both") && (
                  <div className="col-span-6">
                    <LabelArea label={"Select Driver"} required />
                    <Select
                      id="driver-select"
                      options={driverOptions}
                      value={driverOptions?.find(
                        (option) => option.value === selectedDriver,
                      )}
                      onChange={handleDriverChange}
                      placeholder="Select Driver"
                      name="driver"
                      isOptionDisabled={(option) => option.disabled}
                      components={{ IndicatorSeparator }}
                      noOptionsMessage={() => "No drivers found"}
                    />
                    <Error errorName={errors.driver} />
                  </div>
                )}

                <div className="col-span-12">
                  <LabelArea label={"Reason"} required />
                  <InputArea
                    register={register}
                    label="Reason"
                    name="reason"
                    type="text"
                    onChange={(e) => setChangeReason(e.target.value)}
                    placeholder={"Enter Reason"}
                  />
                  <Error errorName={errors.reason} />
                </div>

                <DrawerButton
                  isSubmitting={loading}
                  id={id}
                  title="Update"
                  Action={action}
                  allotname={"Vehicle Or Driver"}
                />
              </div>
            )}

            {/* {console.log(vehicleOptions,driverOptions)} */}
            {step === 1 && action === "allot" && (
              <>
                <div className="grid grid-cols-12 gap-5 mb-6 items-center">
                  <div className="col-span-6">
                    <LabelArea label={"Select Vehicle"} required />
                    {/* {console.log(vehicleOptions,driverOptions)} */}
                    <Select
                      id="vehicle-select"
                      options={vehicleOptions}
                      value={vehicleOptions?.find(
                        (option) => option.value === selectedVehicle,
                      )}
                      onChange={handleChange}
                      placeholder="Select Vehicle"
                      name="vehicle"
                      isOptionDisabled={(option) => option.disabled}
                      components={{ IndicatorSeparator }}
                      noOptionsMessage={() => "No vehicles found"}
                    />
                    <Error errorName={errors.vehicle} />
                  </div>

                  {selectedVehicle && (
                    <div className="col-span-6">
                      <LabelArea label={"Select Driver"} required />
                      <Select
                        id="driver-select"
                        options={driverOptions}
                        value={driverOptions?.find(
                          (option) => option.value === selectedDriver,
                        )}
                        onChange={handleDriverChange}
                        placeholder="Select Driver"
                        name="driver"
                        isOptionDisabled={(option) => option.disabled}
                        components={{ IndicatorSeparator }}
                        noOptionsMessage={() => "No drivers found"}
                      />
                      <Error errorName={errors.driver} />
                    </div>
                  )}
                </div>

                <DrawerButton
                  isSubmitting={loading}
                  id={id}
                  title="Assign"
                  Action={action}
                  allotname={"Vehicle Or Driver"}
                />
              </>
            )}
          </div>
        </form>
      </Scrollbars>
    </>
  );
};

export default VehicleAllotDrawer;
